import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import {
  fetchOperators,
  fetchOperator,
  createOperator,
  updateOperator,
  deleteOperator
} from '../api/operatorsApi.js';

export function useOperators(filters = {}) {
  return useQuery({
    queryKey: ['operators', 'list', filters],
    queryFn: () => fetchOperators(filters),
    placeholderData: keepPreviousData
  });
}

export function useOperator(id) {
  return useQuery({
    queryKey: ['operators', 'detail', id],
    queryFn: () => fetchOperator(id),
    enabled: !!id
  });
}

export function useCreateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createOperator,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['operators'] })
  });
}

export function useUpdateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: updateOperator,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['operators'] })
  });
}

export function useDeleteOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteOperator,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['operators'] })
  });
}
